const langList = {
    id: {
        lang: "id",
        axiosLang: 'ID',
        hello: "Apa kabar",
        today: "Hari ini",
        dayword: "Sepatah kata sehari",
        holiday: "Hari libur",
        holidaySub: "",
        confirm: "Yakin",
        day: "hari",
        days: "hari",
        weeksRow: [
            { id: 0, name: "Min" },
            { id: 1, name: "Sen" },
            { id: 2, name: "Sel" },
            { id: 3, name: "Rab" },
            { id: 4, name: "Kam" },
            { id: 5, name: "Jum" },
            { id: 6, name: "Sab" },
        ],
        monthName: [
            { id: 1, name: "Januari" },
            { id: 2, name: "Februari" },
            { id: 3, name: "Maret" },
            { id: 4, name: "April" },
            { id: 5, name: "Mei" },
            { id: 6, name: "Juni" },
            { id: 7, name: "Juli" },
            { id: 8, name: "Agustus" },
            { id: 9, name: "September" },
            { id: 10, name: "Oktober" },
            { id: 11, name: "November" },
            { id: 12, name: "Desember" },
        ],
        disabledAdd: 'Tidak dapat dioperasikan',
        schedule: "Jadwal",
        creatSchedule: "Buat jadwal",
        editSchedule: "Edit jadwal",
        scheduleTitile: "Judul",
        scheduleDesc: "Deskripsi",
        scheduleStarttime: "Waktu mulai",
        scheduleEndtime: "Waktu selesai",
        scheduleRendertime: "Waktu pengingat",
        schedulePlace: "Lokasi",
        scheduleConfirm: "Konfirmasi",
        scheduleCancel: "Batal",
        columns: [
            { text: 'Tidak ada pengingat', value: 0 },
            { text: 'Ingatkan tepat waktu', value: 1 },
            { text: 'Ingatkan 10 menit sebelumnya', value: 2 },
            { text: 'Ingatkan 20 menit sebelumnya', value: 3 },
            { text: 'Ingatkan 30 menit sebelumnya', value: 4 },
            { text: 'Ingatkan 1 hari sebelumnya', value: 5 },
            { text: 'Ingatkan 2 hari sebelumnya', value: 6 },
            { text: 'Ingatkan 3 hari sebelumnya', value: 7 },
        ],
        selDate: "Pilih tanggal",
        selTime: "Pilih waktu",
        noStart: "Belum dimulai",
        progress: "Sedang berlangsung",
        end: "Telah berakhir",
        noRemind: "Tidak ada pengingat",
        duplicateToast: "Bentrok jadwal",
        delSchedule: 'Hapus',
        noSchedule: "Tidak ada jadwal",
        timeCompareToast: 'Waktu mulai tidak boleh melampaui waktu berakhir'


    },
    es: {
        lang: "es",
        axiosLang: "ES",
        hello: "¿Cómo estás?",
        today: "Hoy",
        dayword: "Frase del día",
        holiday: "Días festivos",
        holidaySub: "",
        confirm: "Aceptar",
        day: "día",
        days: "días",
        weeksRow: [
            { id: 0, name: "Dom" },
            { id: 1, name: "Lun" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Mié" },
            { id: 4, name: "Jue" },
            { id: 5, name: "Vie" },
            { id: 6, name: "Sáb" },
        ],
        monthName: [
            { id: 1, name: "Enero" },
            { id: 2, name: "Febrero" },
            { id: 3, name: "Marzo" },
            { id: 4, name: "April" },
            { id: 5, name: "Mayo" },
            { id: 6, name: "Junio" },
            { id: 7, name: "Julio" },
            { id: 8, name: "Agosto" },
            { id: 9, name: "Septiembre" },
            { id: 10, name: "Octubre" },
            { id: 11, name: "Noviembre" },
            { id: 12, name: "Diciembre" },
        ],
        disabledAdd: 'No operativo',
        schedule: "Calendario",
        creatSchedule: "Crear evento",
        editSchedule: "Editar evento",
        scheduleTitile: "Título",
        scheduleDesc: "Descripción",
        scheduleStarttime: "Hora de inicio",
        scheduleEndtime: "Hora de finalización",
        scheduleRendertime: "Hora de recordatorio",
        schedulePlace: "Ubicación",
        scheduleConfirm: "Confirmar",
        scheduleCancel: "Cancelar",
        columns: [
            { text: 'Sin recordatorio', value: 0 },
            { text: 'Recordar a la hora exacta', value: 1 },
            { text: 'Recordar 10 minutos antes', value: 2 },
            { text: 'Recordar 20 minutos antes', value: 3 },
            { text: 'Recordar 30 minutos antes', value: 4 },
            { text: 'Recordar 1 día antes', value: 5 },
            { text: 'Recordar 2 días antes', value: 6 },
            { text: 'Recordar 3 días antes', value: 7 },
        ],
        selDate: "Seleccionar fecha",
        selTime: "Seleccionar hora",
        noStart: "No iniciado",
        progress: "En curso",
        end: "Finalizado",
        noRemind: "Sin recordatorio",
        duplicateToast: "Conflicto de horarios",
        delSchedule: 'Eliminar',
        noSchedule: "No hay horarios",
        timeCompareToast: 'La hora de inicio no puede ser posterior a la hora de finalización'
    },
    // 西班牙语（拉美）
    es_us: {
        lang: "es_us",
        axiosLang: "ES",
        hello: "¡Hola!",
        today: "Hoy",
        dayword: "Frase del día",
        holiday: "Festivo",
        holidaySub: "",
        confirm: "Aceptar",
        day: "día",
        days: "días",
        weeksRow: [
            { id: 0, name: "Dom" },
            { id: 1, name: "Lun" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Mié" },
            { id: 4, name: "Jue" },
            { id: 5, name: "Vie" },
            { id: 6, name: "Sáb" },
        ],
        monthName: [
            { id: 1, name: "Enero" },
            { id: 2, name: "Febrero" },
            { id: 3, name: "Marzo" },
            { id: 4, name: "Abril" },
            { id: 5, name: "Mayo" },
            { id: 6, name: "Junio" },
            { id: 7, name: "Julio" },
            { id: 8, name: "Agosto" },
            { id: 9, name: "Septiembre" },
            { id: 10, name: "Octubre" },
            { id: 11, name: "Noviembre" },
            { id: 12, name: "Diciembre" },
        ],
        disabledAdd: 'No disponible',
        schedule: "Calendario",
        creatSchedule: "Crear evento",
        editSchedule: "Editar evento",
        scheduleTitile: "Título",
        scheduleDesc: "Descripción",
        scheduleStarttime: "Hora de inicio",
        scheduleEndtime: "Hora de fin",
        scheduleRendertime: "Hora del recordatorio",
        schedulePlace: "Ubicación",
        scheduleConfirm: "Confirmar",
        scheduleCancel: "Cancelar",
        columns: [
            { text: 'Sin recordatorio', value: 0 },
            { text: 'Recordar a la hora exacta', value: 1 },
            { text: 'Recordar 10 minutos antes', value: 2 },
            { text: 'Recordar 20 minutos antes', value: 3 },
            { text: 'Recordar 30 minutos antes', value: 4 },
            { text: 'Recordar 1 día antes', value: 5 },
            { text: 'Recordar 2 días antes', value: 6 },
            { text: 'Recordar 3 días antes', value: 7 },
        ],
        selDate: "Seleccionar fecha",
        selTime: "Seleccionar hora",
        noStart: "No iniciado",
        progress: "En curso",
        end: "Finalizado",
        noRemind: "Sin recordatorio",
        duplicateToast: "El rango de tiempo de la agenda se repite",
        delSchedule: 'Eliminar',
        noSchedule: "Sin horarios disponibles",
        timeCompareToast: 'La hora de inicio no puede ser posterior a la hora de finalización'
    },
    en: {
        lang: "en",
        axiosLang: "GB",
        hello: "Hello",
        today: "Today",
        dayword: "Daily quote",
        holiday: "Holidays",
        holidaySub: "",
        confirm: "Certain",
        day: "day",
        days: "day",
        weeksRow: [
            { id: 0, name: "Sun" },
            { id: 1, name: "Mon" },
            { id: 2, name: "Tue" },
            { id: 3, name: "Wed" },
            { id: 4, name: "Thu" },
            { id: 5, name: "Fri" },
            { id: 6, name: "Sat" },
        ],
        monthName: [
            { id: 1, name: "January" },
            { id: 2, name: "February" },
            { id: 3, name: "March" },
            { id: 4, name: "April" },
            { id: 5, name: "May" },
            { id: 6, name: "June" },
            { id: 7, name: "July" },
            { id: 8, name: "August" },
            { id: 9, name: "September" },
            { id: 10, name: "October" },
            { id: 11, name: "November" },
            { id: 12, name: "December" },
        ],
        disabledAdd: 'Not Operable',
        schedule: "Schedule",
        creatSchedule: "Create Schedule",
        editSchedule: "Edit Schedule",
        scheduleTitile: "Title",
        scheduleDesc: "Description",
        scheduleStarttime: "Start Time",
        scheduleEndtime: "End Time",
        scheduleRendertime: "Reminder Time",
        schedulePlace: "Location",
        columns: [
            { text: 'No reminder', value: 0 },
            { text: 'Remind On Time', value: 1 },
            { text: 'Remind 10 minutes before', value: 2 },
            { text: 'Remind 20 minutes before', value: 3 },
            { text: 'Remind 30 minutes before', value: 4 },
            { text: 'Remind 1 day before', value: 5 },
            { text: 'Remind 2 days before', value: 6 },
            { text: 'Remind 3 days before', value: 7 },
        ],
        noStart: "Not started",
        progress: "In progress",
        end: "Finished",
        noRemind: "No reminder",
        duplicateToast: "Schedule Time Range Overlaps",
        delSchedule: 'Delete',
        noSchedule: "No Schedule Available",
        timeCompareToast: 'The start time cannot be later than the end time'
    },
    en_gb: {
        lang: "en_gb",
        axiosLang: "GB",
        hello: "Hello",
        today: "Today",
        dayword: "Daily quote",
        holiday: "Holiday",
        holidaySub: "",
        confirm: "OK",
        day: "day",
        days: "days",
        weeksRow: [
            { id: 0, name: "Sun" },
            { id: 1, name: "Mon" },
            { id: 2, name: "Tue" },
            { id: 3, name: "Wed" },
            { id: 4, name: "Thu" },
            { id: 5, name: "Fri" },
            { id: 6, name: "Sat" },
        ],
        monthName: [
            { id: 1, name: "January" },
            { id: 2, name: "February" },
            { id: 3, name: "March" },
            { id: 4, name: "April" },
            { id: 5, name: "May" },
            { id: 6, name: "June" },
            { id: 7, name: "July" },
            { id: 8, name: "August" },
            { id: 9, name: "September" },
            { id: 10, name: "October" },
            { id: 11, name: "November" },
            { id: 12, name: "December" },
        ],
        disabledAdd: 'Unavailable',
        schedule: "Schedule",
        creatSchedule: "Create event",
        editSchedule: "Edit event",
        scheduleTitile: "Title",
        scheduleDesc: "Description",
        scheduleStarttime: "Start time",
        scheduleEndtime: "End time",
        scheduleRendertime: "Reminder time",
        schedulePlace: "Location",
        columns: [
            { text: 'No reminder', value: 0 },
            { text: 'Remind on time', value: 1 },
            { text: 'Remind 10 minutes before', value: 2 },
            { text: 'Remind 20 minutes before', value: 3 },
            { text: 'Remind 30 minutes before', value: 4 },
            { text: 'Remind 1 day before', value: 5 },
            { text: 'Remind 2 days before', value: 6 },
            { text: 'Remind 3 days before', value: 7 },
        ],
        noStart: "Not started",
        progress: "In progress",
        end: "Finished",
        noRemind: "No reminder",
        duplicateToast: "Schedule Time Range Overlaps",
        delSchedule: 'Delete',
        noSchedule: "No schedule available",
        timeCompareToast: 'The start time cannot be later than the end time'
    },
    ru: {
        lang: "ru",
        axiosLang: "RU",
        hello: "Привет!",
        today: "Сегодня",
        dayword: "Ежедневная цитата",
        holiday: "Праздник ",
        holidaySub: "",
        confirm: "Подтвердить",
        day: "День",
        days: "День",
        weeksRow: [
            { id: 0, name: "Вс" },
            { id: 1, name: "Пн" },
            { id: 2, name: "Вт" },
            { id: 3, name: "Ср" },
            { id: 4, name: "Чт" },
            { id: 5, name: "Пт" },
            { id: 6, name: "Сб" },
        ],
        monthName: [
            { id: 1, name: "Январь" },
            { id: 2, name: "Февраль" },
            { id: 3, name: "Март" },
            { id: 4, name: "Апрель" },
            { id: 5, name: "Май" },
            { id: 6, name: "Июнь" },
            { id: 7, name: "Июль" },
            { id: 8, name: "Август" },
            { id: 9, name: "Сентябрь" },
            { id: 10, name: "Октябрь" },
            { id: 11, name: "Ноябрь" },
            { id: 12, name: "Декабрь" },
        ],
        disabledAdd: 'Неоперабельно',
        schedule: "Событие",
        creatSchedule: "Создать событие",
        editSchedule: "Редактировать событие",
        scheduleTitile: "Заголовок",
        scheduleStarttime: "Время начала",
        scheduleEndtime: "Время окончания",
        scheduleRendertime: "Время напоминания",
        schedulePlace: "Место",
        scheduleDesc: "Описание",
        columns: [
            { text: 'Без напоминания', value: 0 },
            { text: 'В момент события', value: 1 },
            { text: 'За 10 минут', value: 2 },
            { text: 'За 20 минут', value: 3 },
            { text: 'За 30 минут', value: 4 },
            { text: 'За 1 день', value: 5 },
            { text: 'За 2 день', value: 6 },
            { text: 'За 3 день', value: 7 },
        ],
        noStart: "Не начато",
        progress: "Завершено",
        end: "В процессе",
        noRemind: "Без напоминания",
        duplicateToast: "Временные рамки расписания пересекаются",
        delSchedule: 'Удалить',
        noSchedule: "Нет доступного расписания",
        timeCompareToast: 'Время начала не может быть позже времени окончания'
    },
    fr: {
        lang: "fr",
        axiosLang: "FR",
        hello: "Bonjour",
        today: "Aujourd'hui",
        dayword: "Citation du jour",
        holiday: "Vacances",
        holidaySub: "",
        confirm: "OK",
        day: "jour",
        days: "jour",
        weeksRow: [
            { id: 0, name: "Dim" },
            { id: 1, name: "Lun" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Mer" },
            { id: 4, name: "Jeu" },
            { id: 5, name: "Ven" },
            { id: 6, name: "Sam" },
        ],
        monthName: [
            { id: 1, name: "Janvier" },
            { id: 2, name: "Février" },
            { id: 3, name: "Mars" },
            { id: 4, name: "Avril" },
            { id: 5, name: "Mai" },
            { id: 6, name: "Juin" },
            { id: 7, name: "Juillet" },
            { id: 8, name: "Août" },
            { id: 9, name: "Septembre" },
            { id: 10, name: "Octobre" },
            { id: 11, name: "Novembre" },
            { id: 12, name: "Décembre" },
        ],
        disabledAdd: 'Indisponible',
        schedule: "Calendrier",
        creatSchedule: "Créer un événement",
        editSchedule: "Modifier l’événement",
        scheduleTitile: "Titre",
        scheduleDesc: "Description",
        scheduleStarttime: "Heure de début",
        scheduleEndtime: "Heure de fin",
        scheduleRendertime: "Heure de rappel",
        schedulePlace: "Lieu",
        columns: [
            { text: 'Pas de rappel', value: 0 },
            { text: "Rappeler à l'heure", value: 1 },
            { text: "Rappeler 10 minutes avant", value: 2 },
            { text: "Rappeler 20 minutes avant", value: 3 },
            { text: "Rappeler 30 minutes avant", value: 4 },
            { text: "Rappeler 1 jour avant", value: 5 },
            { text: "Rappeler 2 jours avant", value: 6 },
            { text: "Rappeler 3 jours avant", value: 7 },
        ],
        noStart: "Pas commencé",
        progress: "En cours",
        end: "Terminé",
        noRemind: "Pas de rappel",
        duplicateToast: "La plage horaire du calendrier se répète",
        delSchedule: 'Supprimer',
        noSchedule: "Aucun horaire disponible"
    },
    it: {
        lang: "it",
        axiosLang: "IT",
        hello: "Ciao",
        today: "Oggi",
        dayword: "Citazione quotidiana",
        holiday: "Vacanza",
        holidaySub: " ",
        confirm: "Confermare",
        day: "Giorno",
        days: "Giorno",
        weeksRow: [
            { id: 0, name: "Dom" },
            { id: 1, name: "Lun" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Mer" },
            { id: 4, name: "Gio" },
            { id: 5, name: "Ven" },
            { id: 6, name: "Sab" },
        ],
        monthName: [
            { id: 1, name: "Gennaio" },
            { id: 2, name: "Febbraio" },
            { id: 3, name: "Marzo" },
            { id: 4, name: "Aprile" },
            { id: 5, name: "Maggio" },
            { id: 6, name: "Giugno" },
            { id: 7, name: "Luglio" },
            { id: 8, name: "Agosto" },
            { id: 9, name: "Settembre" },
            { id: 10, name: "Ottobre" },
            { id: 11, name: "Novembre" },
            { id: 12, name: "Dicembre" },
        ],
        disabledAdd: 'Non operabile',
        schedule: "Programma",
        creatSchedule: "Crea programma",
        editSchedule: "Modifica programma",
        scheduleTitile: "Titolo",
        scheduleDesc: "Descrizione",
        scheduleStarttime: "Ora di inizio",
        scheduleEndtime: "Ora di fine",
        scheduleRendertime: "Ora di promemoria",
        schedulePlace: "Luogo",
        columns: [
            { text: 'Nessun promemoria', value: 0 },
            { text: 'Ricorda in orario', value: 1 },
            { text: 'Ricorda 10 minuti prima', value: 2 },
            { text: 'Ricorda 20 minuti prima', value: 3 },
            { text: 'Ricorda 30 minuti prima', value: 4 },
            { text: 'Ricorda 1 giorno prima', value: 5 },
            { text: 'Ricorda 2 giorno prima', value: 6 },
            { text: 'Ricorda 3 giorno prima', value: 7 },
        ],
        noStart: "Non iniziato",
        progress: "In corso",
        end: "Finito",
        noRemind: "Nessun promemoria",
        duplicateToast: "Intervallo di tempo del programma si sovrappone",
        delSchedule: 'Elimina',
        noSchedule: "Nessun programma disponibile"
    },
    br: {
        lang: "br",
        axiosLang: "BR",
        hello: "Olá",
        today: "Hoje",
        dayword: "Citação diária",
        holiday: "Férias",
        holidaySub: " ",
        confirm: "Confirmar",
        day: "Dia",
        days: "Dia",
        weeksRow: [
            { id: 0, name: "Dom" },
            { id: 1, name: "Seg" },
            { id: 2, name: "Ter" },
            { id: 3, name: "Qua" },
            { id: 4, name: "Qui" },
            { id: 5, name: "Sex" },
            { id: 6, name: "Sáb" },
        ],
        monthName: [
            { id: 1, name: "Janeiro" },
            { id: 2, name: "Fevereiro" },
            { id: 3, name: "Março" },
            { id: 4, name: "Abril" },
            { id: 5, name: "Maio" },
            { id: 6, name: "Junho" },
            { id: 7, name: "Julho" },
            { id: 8, name: "Agosto" },
            { id: 9, name: "Setembro" },
            { id: 10, name: "Outubro" },
            { id: 11, name: "Novembro" },
            { id: 12, name: "Dezembro" },
        ],
        disabledAdd: 'Não operável',
        schedule: "Agenda",
        creatSchedule: "Criar evento",
        editSchedule: "Editar evento",
        scheduleTitile: "Título",
        scheduleDesc: "Descrição",
        scheduleStarttime: "Hora de início",
        scheduleEndtime: "Hora de término",
        scheduleRendertime: "Hora de lembrete",
        schedulePlace: "Local",
        columns: [
            { text: 'Sem lembrete', value: 0 },
            { text: 'Lembrar na hora', value: 1 },
            { text: 'Lembrar 10 minutos antes', value: 2 },
            { text: 'Lembrar 20 minutos antes', value: 3 },
            { text: 'Lembrar 30 minutos antes', value: 4 },
            { text: 'Lembrar 1 dia antes', value: 5 },
            { text: 'Lembrar 2 dia antes', value: 6 },
            { text: 'Lembrar 3 dia antes', value: 7 },
        ],
        noStart: "Não iniciado",
        progress: "Em andamento",
        end: "Finalizado",
        noRemind: "Sem lembrete",
        duplicateToast: "Intervalo de tempo da agenda se sobrepõe",
        delSchedule: 'Excluir',
        noSchedule: "Nenhuma agenda disponível",
        timeCompareToast: 'A hora de início não pode ser posterior à hora de término'
    },
    tr: {
        lang: "tr",
        axiosLang: "TR",
        hello: "Merhaba",
        today: "Bugün",
        dayword: "Günün sözü",
        holiday: "Tatil",
        holidaySub: " ",
        confirm: "Tamam",
        day: "gün",
        days: "gün",
        weeksRow: [
            { id: 0, name: "Paz" },
            { id: 1, name: "Pzt" },
            { id: 2, name: "Sal" },
            { id: 3, name: "Çar" },
            { id: 4, name: "Per" },
            { id: 5, name: "Cum" },
            { id: 6, name: "Cmt" },
        ],
        monthName: [
            { id: 1, name: "Ocak" },
            { id: 2, name: "Şubat" },
            { id: 3, name: "Mart" },
            { id: 4, name: "Nisan" },
            { id: 5, name: "Mayıs" },
            { id: 6, name: "Haziran" },
            { id: 7, name: "Temmuz" },
            { id: 8, name: "Ağustos" },
            { id: 9, name: "Eylül" },
            { id: 10, name: "Ekim" },
            { id: 11, name: "Kasım" },
            { id: 12, name: "Aralık" },
        ],
        disabledAdd: 'Kullanılamaz',
        schedule: "Takvim",
        creatSchedule: "Etkinlik oluştur",
        editSchedule: "Etkinliği düzenle",
        scheduleTitile: "Başlık",
        scheduleDesc: "Açıklama",
        scheduleStarttime: "Başlangıç saati",
        scheduleEndtime: "Bitiş saati",
        scheduleRendertime: "Hatırlatma saati",
        schedulePlace: "Konum",
        columns: [
            { text: 'Hatırlatıcı yok', value: 0 },
            { text: 'Zamanında hatırlat', value: 1 },
            { text: '10 dakika önce hatırlat', value: 2 },
            { text: '20 dakika önce hatırlat', value: 3 },
            { text: '30 dakika önce hatırlat', value: 4 },
            { text: '1 gün önce hatırlat', value: 5 },
            { text: '2 gün önce hatırlat', value: 6 },
            { text: '3 gün önce hatırlat', value: 7 },
        ],
        noStart: "Başlamadı",
        progress: "Devam ediyor",
        end: "Tamamlandı",
        noRemind: "Hatırlatıcı yok",
        duplicateToast: "Program zaman aralığı çakışıyor",
        delSchedule: 'Sil',
        noSchedule: "Hiçbir program yok"
    },
    de: {
        lang: "de",
        axiosLang: "DE",
        hello: "Hallo",
        today: "Heute",
        dayword: "Tageszitat",
        holiday: "Feiertag",
        holidaySub: "Holidays are still far away...",
        confirm: "OK",
        day: "Tag",
        days: "Tage",
        weeksRow: [
            { id: 0, name: "So" },
            { id: 1, name: "Mo" },
            { id: 2, name: "Di" },
            { id: 3, name: "Mi" },
            { id: 4, name: "Do" },
            { id: 5, name: "Fr" },
            { id: 6, name: "Sa" },
        ],
        monthName: [
            { id: 1, name: "Januar" },
            { id: 2, name: "Februar" },
            { id: 3, name: "März" },
            { id: 4, name: "April" },
            { id: 5, name: "Mai" },
            { id: 6, name: "Juni" },
            { id: 7, name: "Juli" },
            { id: 8, name: "August" },
            { id: 9, name: "September" },
            { id: 10, name: "Oktober" },
            { id: 11, name: "November" },
            { id: 12, name: "Dezember" },
        ],
        disabledAdd: 'Nicht bedienbar',
        schedule: "Kalender",
        creatSchedule: "Ereignis erstellen",
        editSchedule: "Ereignis bearbeiten",
        scheduleTitile: "Titel",
        scheduleDesc: "Beschreibung",
        scheduleStarttime: "Startzeit",
        scheduleEndtime: "Endzeit",
        scheduleRendertime: "Erinnerungszeit",
        schedulePlace: "Ort",
        columns: [
            { text: 'Keine Erinnerung', value: 0 },
            { text: 'Pünktlich erinnern', value: 1 },
            { text: '10 Minuten vorher erinnern', value: 2 },
            { text: '20 Minuten vorher erinnern', value: 3 },
            { text: '30 Minuten vorher erinnern', value: 4 },
            { text: '1 Tag vorher erinnern', value: 5 },
            { text: '2 Tage vorher erinnern', value: 6 },
            { text: '3 Tage vorher erinnern', value: 7 },
        ],
        noStart: "Nicht begonnen",
        progress: "Läuft",
        end: "Beendet",
        noRemind: "Keine Erinnerung",
        duplicateToast: "Zeitbereich des Zeitplans überschneidet sich",
        delSchedule: 'Löschen',
        noSchedule: "Kein Zeitplan verfügbar"
    },
}
export const getLang = (lang) => {

    // let obj = langList['id']
    // if (lang) {
    //     console.log(langList[lang])
    //     return obj = langList[lang]
    // }
    // let customLang = ''
    // let customColor = ""
    // let customArr = import.meta.env && import.meta.env.VITE_CUSTOM_ARR.split(",")
    // customArr.forEach(item => {
    //     if (item.includes("VITE_CAN_COLOR")) {
    //         customColor = item.split("=")?.[1]
    //         obj.customColor = customColor
    //     }

    //     if (item.includes("VITE_CUSTOM_LANG")) {
    //         customLang = item.split("=")?.[1]
    //     }
    // });
    // if (customLang) {
    //     obj = langList[customLang]
    // }
    // console.log("can", obj)
    // return obj
    let obj = {}
    const params = new URLSearchParams(window.location.search);
    const paramLang = params.get('lang');
    const browserLang = navigator.language || navigator.userLanguage;
    let countryArr = ['de', 'en', 'id', 'es', 'ru', 'fr', 'it', 'pt', 'tr', 'br']
    if (paramLang) {
        console.log("444")
        let str = ''
        paramLang.toLowerCase() == 'in_id' ? str = 'id' : str = paramLang.slice(0, 2)
        if (paramLang.toLowerCase() == 'pt_br' || paramLang.toLowerCase() == 'pt') {
            str = 'br'
        }
        obj = langList[str]
    } else if (browserLang && countryArr.includes(browserLang.toLowerCase().slice(0, 2))) {
        let str = ""
        str = browserLang.toLowerCase().slice(0, 2)
        if (browserLang.toLowerCase().slice(0, 2) == 'pt') {
            str = 'br'
        }
        console.log(str, "str")
        obj = langList[str]
    } else {
        obj = langList['en']
    }

    return obj
}
